import { FC, ReactNode } from "react";
import { AiFillBank } from "react-icons/ai";
import { FaBarcode, FaCreditCard, FaQrcode, FaFileAlt, FaPlus } from "react-icons/fa";
import BNDES from "src/components/utils/BNDES";
import { BOLETO, CARTAO_CREDITO, PIX, FINANCIAMENTO, FINANCIMENTO_INDIRETO, PIX_CARTAO, PIX_FINANCIAMENTO_INDIRETO, PIX_FINANCIAMENTO, BOLETO_CARTAO, BOLETO_FINANCIAMENTO_INDIRETO, BOLETO_FINANCIAMENTO, CARTAO_CREDITO_FINANCIAMENTO_INDIRETO, CARTAO_FINANCIAMENTO, FINAME } from "src/constants";
import { TiposPagamentoIDType } from "src/types";

interface FormaPagamentoIconsProperties {
    tipoPagamentoId: TiposPagamentoIDType
}

const FormaPagamentoIcons: FC<FormaPagamentoIconsProperties> = ({
    tipoPagamentoId
}) => {
    const renderIcon = (tipoPagamentoId: TiposPagamentoIDType): ReactNode => {
        switch (tipoPagamentoId) {
            case BOLETO.id:
                return <FaBarcode />
            case CARTAO_CREDITO.id:
                return <FaCreditCard />
            case PIX.id:
                return <FaQrcode />
            case FINANCIAMENTO.id:
                return <AiFillBank />
            case FINAME.id:
                    return <BNDES className="bndes-icon" />
            case FINANCIMENTO_INDIRETO.id:
                return <FaFileAlt />
            case PIX_CARTAO.id:
                return <><FaQrcode /><FaPlus className='plus'/><FaCreditCard /></>
            case PIX_FINANCIAMENTO_INDIRETO.id:
                return <><FaQrcode /><FaPlus className='plus'/><FaFileAlt /></>
            case PIX_FINANCIAMENTO.id:
                return <><FaQrcode /><FaPlus className='plus'/><AiFillBank /></>
            case BOLETO_CARTAO.id:
                return <><FaBarcode /><FaPlus className='plus'/><FaCreditCard /></>
            case BOLETO_FINANCIAMENTO_INDIRETO.id:
                return <><FaBarcode /><FaPlus className='plus'/><FaFileAlt /></>
            case BOLETO_FINANCIAMENTO.id:
                return <><FaBarcode /><FaPlus className='plus'/><AiFillBank /></>
            case CARTAO_CREDITO_FINANCIAMENTO_INDIRETO.id:
                return <><FaCreditCard /><FaPlus className='plus'/><FaFileAlt /></>
            case CARTAO_FINANCIAMENTO.id:
                return <><FaCreditCard /><FaPlus className='plus'/><AiFillBank /></>
            
        }

        return <></>
    }

    return <>{renderIcon(tipoPagamentoId)}</>
}

export { FormaPagamentoIcons }